import CompanyLogo from "assets/images/companyLogo.png";
import favicon from "assets/images/favicon.ico";

export const companyDetails = {
    companyName: "ITER-Corporate",
    companyLogo: CompanyLogo,
    favicon:favicon
}